import {atomicScopes} from '@wix/document-services-implementation'

export default function () {
    return {
        initMethod: atomicScopes.initialize
    }
}
